const AuthenticationInterceptors = () => {
	const addTokenExpiredInterceptor = (serviceInstance, authService) => {
		serviceInstance.interceptors.request.use((config) => {
			// eslint-disable-next-line no-param-reassign
			config.headers.Authorization = `Bearer ${authService.getAuthToken()}`;

			return config;
		});

		serviceInstance.interceptors.response.use(
			(res) => res,
			async (err) => {
				const { config, response } = err;
				if (response?.status === 401) {
					try {
						const { refresh } = authService;
						const refreshToken = await refresh();

						if (refreshToken) {
							return serviceInstance(config);
						}
					} catch (e) {
						window.location = "/";
					}
				}

				return Promise.reject(err);
			}
		);
	};

	return {
		addTokenExpiredInterceptor
	};
};

export default AuthenticationInterceptors();
